__turbopack_context__.v({
  "active": "Compass-module-scss-module__luASyq__active",
  "compass": "Compass-module-scss-module__luASyq__compass",
  "compassGenplanMob": "Compass-module-scss-module__luASyq__compassGenplanMob",
});
